export default __webpack_public_path__ + "static/media/consultancy.d3539955.jpg";